import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const cMcustomerApi = createApi({
  reducerPath: 'cMcustomerApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'Customers',
  ],
  endpoints: builder => ({
    getCustomers: builder.query({
      query: (params) => ({
        url: `/customers/`,
        params,
      }),
      providesTags: ['Customers']
    }),

    addCustomer: builder.mutation({
      query: body => ({
        url: '/customers/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Customers']
    }),

    getCustomerById: builder.query({
      query: id => ({
        url: `/customers/${id}/`
      }),
      providesTags: ['Customers']
    }),

    updateCustomer: builder.mutation({
      query: ({ id, body }) => ({
        url: `/customers/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Customers']
    }),

    deleteCustomer: builder.mutation({
      query: id => ({
        url: `/customers/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Customers']
    }),

    
  })
})

export const {
  useGetCustomersQuery,
  useLazyGetCustomersQuery,
  useAddCustomerMutation,
  useGetCustomerByIdQuery,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
} = cMcustomerApi
